module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"interval-filter:start":"Начало","interval-filter:end":"Окончание","interval-filter:accept":"Применить","interval-filter:reset":"Сброс"},"en":{"interval-filter:start":"Start","interval-filter:end":"End","interval-filter:accept":"Accept","interval-filter:reset":"Reset"}}')
  delete Component.options._Ctor
}
